export default __webpack_public_path__ + "static/media/InkedVerses_final.e07d92e0.jpg";